import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#878787",
      "fill-rule": "evenodd",
      d: "M10.656 3.657a1.9 1.9 0 0 1 2.687 0l6.707 6.707a2.9 2.9 0 0 1 .85 2.05V21a.9.9 0 0 1-.9.9h-5.5a.9.9 0 0 1-.9-.9v-4.5a1.6 1.6 0 1 0-3.2 0V21a.9.9 0 0 1-.9.9H4a.9.9 0 0 1-.9-.9v-8.586a2.9 2.9 0 0 1 .85-2.05zM12.07 4.93a.1.1 0 0 0-.14-.001l-6.708 6.708a1.1 1.1 0 0 0-.322.777V20.1h3.7v-3.6a3.4 3.4 0 1 1 6.8 0v3.6h3.7v-7.686a1.1 1.1 0 0 0-.323-.777z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }